export type EmbeddingProviderSlug = "google" | "openai";

const GOOGLE_EMBEDDING_MODEL_PREFIX = "gemini-";

/**
 * Which organization API key an embedding model is billed to. Mirrors the
 * routing rule in `@arti/vector-persistence` `resolveEmbeddingModel`: Gemini
 * models go to Google Generative AI, everything else to OpenAI. The dashboard
 * uses it to tell an organization which key semantic search depends on.
 */
export function getEmbeddingProviderSlug(
  modelRef: string,
): EmbeddingProviderSlug {
  return modelRef.startsWith(GOOGLE_EMBEDDING_MODEL_PREFIX)
    ? "google"
    : "openai";
}
